import { useDispatch } from 'react-redux';

import { IBankModalContent, IBuilderModalContent, EModalType, IOffer } from '../../types';

import { openModal } from '../../redux';
import { IGetOffersV1Response } from '../../../common/repositories/mortgage-broker-calculator/entities/get_offers_listing_for_newbuiling/GetOffersV1Response';

import { useIsDesktop } from '../../hooks/useIsDesktop';
import { MobileListingContainer } from '../MobileListingContainer';
import { DesktopListingContainer } from '../DesktopListingContainer';
import { LoaderBlock } from '../../components/LoaderBlock';
import { SomethingWentWrong } from '../../components/SomethingWentWrong';
import { OfferEmpty } from '../../components/OfferEmpty';

interface IListingContainerProps {
  data: IGetOffersV1Response | undefined;
  isFetching: boolean;
  error: unknown;
  refetch: () => void;
}

export const ListingContainer = (props: IListingContainerProps) => {
  const { data, isFetching, error, refetch } = props;
  const isDesktop = useIsDesktop();
  const dispatch = useDispatch();

  if ((isDesktop && isFetching) || !data) {
    return <LoaderBlock />;
  } else if (error) {
    return <SomethingWentWrong onClick={() => refetch()} />;
  } else if (data.offers.length === 0) {
    return <OfferEmpty />;
  }

  const handleOpenModal = (offer: IOffer) => () => {
    const { offerName, offerDescription, iconPath, type } = offer;
    const baseContent = { offerName, offerDescription, iconPath };

    const modalContent =
      offer.type === EModalType.BANK
        ? { ...baseContent, ...(offer.modal as IBankModalContent) }
        : {
            ...baseContent,
            ...(offer.modal as IBuilderModalContent),
            rate: offer.rate,
            monthlyPayment: offer.monthlyPayment,
          };

    dispatch(openModal({ content: modalContent, type }));
  };

  return isDesktop ? (
    <DesktopListingContainer offerList={data.offers} onCardClick={handleOpenModal} />
  ) : (
    <MobileListingContainer
      offerList={data.offers}
      offerSummary={{
        minRate: Number(data.meta.minRate),
        minMonthlyPayment: Number(data.meta.minMonthlyPayment),
        totalOffersCount: data.meta.totalOffersCount,
        bankLogosPaths: data.meta.banksLogosPaths,
      }}
      onCardClick={handleOpenModal}
      isLoading={isFetching}
    />
  );
};
